import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const subtitles = [
  'for your next team building',
  'to host your wedding',
  'for your corporate event',
  'to celebrate in style',
  'for your next meeting'
];

export const Hero: React.FC = () => {
  const [currentSubtitle, setCurrentSubtitle] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const text = subtitles[index];
    const speed = isDeleting ? 50 : 100;

    if (!isDeleting && currentSubtitle === text) {
      // Wait before starting to delete
      setTimeout(() => setIsDeleting(true), 1500);
      return;
    }

    if (isDeleting && currentSubtitle === '') {
      setIsDeleting(false);
      setIndex((prev) => (prev + 1) % subtitles.length);
      return;
    }

    const timeout = setTimeout(() => {
      setCurrentSubtitle(prev => 
        isDeleting 
          ? prev.slice(0, -1)
          : text.slice(0, prev.length + 1)
      );
    }, speed);

    return () => clearTimeout(timeout);
  }, [currentSubtitle, isDeleting, index]);

  return (
    <div className="relative h-[65vh] flex items-center justify-center bg-[#20232c]">
      <div className="absolute inset-0">
        <img
          src="/assets/images/Mary.jpg"
          alt="Hero background"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-[#20232c]/60" />
      </div>
      
      <div className="relative text-center z-10">
        <h1 className="text-6xl font-semibold text-white mb-4">
          Find the perfect conference
        </h1>
        <p className="text-2xl text-[#d0b286] h-8 mb-8">
          {currentSubtitle}
          <span className="border-r-2 border-[#d0b286] ml-1 animate-pulse">|</span>
        </p>
        
        <Link 
          to="/konferens-kartan"
          className="inline-flex items-center px-8 py-4 text-lg font-medium text-[#20232c] bg-[#d0b286] rounded-lg hover:bg-[#d0b286]/90 transition-colors duration-300"
        >
          Explore Map
        </Link>
      </div>
    </div>
  );
}; 